import { Button, Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

export namespace CreatingWithdrawalErrorTypes {
  export interface Props {
    onReset: VoidFunction;
    onRetry: VoidFunction;
  }
}

export const CreatingWithdrawalError: React.FC<CreatingWithdrawalErrorTypes.Props> = ({
  onRetry,
  onReset,
}) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <Shadow level={1} padding={Spacing['inset.md']}>
        <VStack space={Spacing['stack.xxxs']}>
          <VStack alignItems="center" space={Spacing['stack.xxxs']}>
            <Icon name="Error" size="xl" color={Color['feedback.error.default']} />
            <Text fontSize={Typography['fontsize.lg']} variant="semibold">
              Ops! Algo deu errado
            </Text>
          </VStack>
          <VStack
            paddingX={Spacing['inset.sm']}
            paddingY={Spacing['inset.xs']}
            space={Spacing['stack.nano']}
            backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.7)}
            borderRadius={BoxRadius.sm}>
            <HStack justifyContent="space-between">
              <Text>Valor de saque:</Text>
              <Text variant="semibold">R$ --</Text>
            </HStack>
            <HStack justifyContent="space-between">
              <Text>Data de solicitação:</Text>
              <Text variant="semibold">--</Text>
            </HStack>
            <HStack justifyContent="space-between">
              <Text>Data para saque:</Text>
              <Text variant="semibold">--</Text>
            </HStack>
          </VStack>
        </VStack>
      </Shadow>
      <HStack justifyContent="space-between">
        <Button variant="secondary" onPress={onReset}>
          Novo Saque
        </Button>
        <Button variant="primary" onPress={onRetry}>
          Tentar novamente
        </Button>
      </HStack>
    </VStack>
  );
};
